<template>
    <b-card title="گزارش برداشت ها از بانک آینده">
      <b-modal
        id="transaction-verification"
        title="تایید تراکنش"
        @ok="VerifyTransaction"
        ok-title="بلی"
        cancel-title="خیر"
      >
        آیا از تایید تراکنش اطمینان دارید؟
      </b-modal>
      <b-row>
        <b-col cols="12" md="3" sm="6">
          <b-form-group label="تاریخ:">
            <date-picker v-model="date" clearable></date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" sm="6">
          <b-button class="mr-2" variant="success" @click="getdata()"
            >جستجو</b-button
          >
          <b-button variant="danger" @click="exportExcel()"
            >دریافت فایل اکسل</b-button
          >
        </b-col>
      </b-row>
      <div class="row pt-5">
        <div class="col-md-4">
          <b-form-group label="مبلغ برداشت شده از حساب:">
            <div class="form-control">
              {{ Number(bardashtShode).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="کارمزد شپا برداشت نشده:">
            <div class="form-control">
              {{ Number(karmozdha).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="کارمزد شاپرک برداشت شده:">
            <div class="form-control">
              {{ Number(karmozdha_psp).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-12">
          <b-form-group label="جزییات برداشت:">
            <b-table responsive :items="records" :fields="bardashtReezFields">
              <template v-slot:cell(details)="row">
                <div class="collect-link">
                  <b-button
                    @click="showVerifyModal(row.item)"
                    v-if="row.item.is_verify == false"
                    class="btn btn-primary btn-sm p-0 pl-1 pr-1 mr-1"
                    >تایید تراکنش</b-button
                  >
                </div>
              </template>
            </b-table>
          </b-form-group>
        </div>
      </div>
    </b-card>
  </template>
  <script>
  import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
  import httpHelper from "../../helpers/httpHelper";
  import persianDate from "../../helpers/persianDate";
  import NumberSeprator from "@/components/numberSeprator";
  import { saveExcel } from "@progress/kendo-vue-excel-export";
  import _ from "lodash";
  export default {
    name: "ayandereport",
    components: {
      NumberSeprator,
    },
    data() {
      return {
        id_for_verify: null,
        date: persianDate.getDateByFormat(new Date()),
        bardashtShode: 0,
        website_name: null,
        tracking_number: null,
        karmozdha: 0,
        karmozdha_psp: 0,
        records: [],
        karmozdReezFields: [
          {
            key: "gateway.website_name",
            label: "وبسایت",
          },
          {
            key: "bed",
            label: "مبلغ",
            formatter: (value, key, item) => {
              return Number(value).toLocaleString();
            },
          },
          {
            key: "bank",
            label: "بانک",
          },
        ],
        bardashtReezFields: [
          {
            key: "gateway.website_name",
            label: "وبسایت",
          },
          {
            key: "gateway.website",
            label: "آدرس وبسایت",
          },
          {
            key: "sale_refrence_id",
            label: "کد رهگیری پرداخت",
          },
          {
            key: "cost",
            label: "مبلغ",
            formatter: (value, key, item) => {
              return Number(-1 * value).toLocaleString();
            },
          },
          {
            key: "shepa_karmozd",
            label: "کارمزد شپا",
            formatter: (value, key, item) => {
              if (value < 0) {
                return Number(-1 * value).toLocaleString();
              }
              return value;
            },
          },
          {
            key: "shaparak_karmozd",
            label: "کارمزد نظام بانکی",
            formatter: (value, key, item) => {
              if (value < 0) {
                return Number(-1 * value).toLocaleString();
              }
              return value;
            },
          },
          {
            key: "shepa_wage_type3",
            label: "کارمزد شپا",
            formatter: (value, key, item) => {
              if (value < 0) {
                return Number(-1 * value).toLocaleString();
              }
              return value;
            },
          },
          {
            key: "shaparak_wage_type3",
            label: "کارمزد نظام بانکی",
            formatter: (value, key, item) => {
              if (value < 0) {
                return Number(-1 * value).toLocaleString();
              }
              return value;
            },
          },
          {
            key: "details",
            label: "تایید تراکنش",
          },
        ],
      };
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "گزارش برداشت ها از بانک آینده" },
      ]);
      this.getdata();
    },
    methods: {
      exportExcel() {
        saveExcel({
          data: this.records,
          fileName: "settlements",
          columns: [
            {
              title: "وبسایت",
              field: "gateway.website_name",
            },
            {
              title: "آدرس وبسایت",
              field: "gateway.website",
            },
            {
              title: "کد رهگیری پرداخت",
              field: "sale_refrence_id",
            },
            {
              title: "مبلغ",
              field: "cost",
            },
            {
              title: "کارمزد شپا",
              field: "shepa_karmozd",
            },
            {
              title: "کارمزد شاپرک",
              field: "shaparak_karmozd",
            },
            {
              title: "کارمزد شپا نوع ۳",
              field: "shepa_wage_type3",
            },
            {
              title: "کارمزد شاپرک نوع ۳",
              field: "shaparak_wage_type3",
            },
          ],
        });
      },
      showVerifyModal(e) {
        this.id_for_verify = e.id;
        this.$bvModal.show("transaction-verification");
      },
      VerifyTransaction(e) {
        e.preventDefault();
        httpHelper
          .getData(
            "~transaction/transaction/admin/verify_trans/" + this.id_for_verify
          )
          .then((res) => {
            this.records = [];
            this.$bvModal.hide("transaction-verification");
            this.getdata();
          });
      },
      CalcResult(data) {
        this.bardashtShode = _.sumBy(data, function (o) {
          return -1 * o.cost;
        });
        this.karmozdha = _.sumBy(data, function (o) {
          return o.shepa_karmozd < 0 ? -1 * o.shepa_karmozd : 0;
        });
        this.karmozdha_psp = _.sumBy(data, function (o) {
          return o.shaparak_karmozd < 0 ? -1 * o.shaparak_karmozd : 0;
        });
      },
      getdata() {
        var url = "~transaction/operation/PayoutsBySettleDate?date=" + this.date;
        if (this.website_name) {
          url += "&website_name=" + this.website_name;
        }
        if (this.tracking_number) {
          url += "&tracking_number=" + this.tracking_number;
        }
        if (this.amount) {
          url += "&website_name=" + this.amount;
        }
        httpHelper.getData(url).then((res) => {
          this.records = res.result;
          this.CalcResult(this.records);
        });
      },
    },
  };
  </script>